import { Anchor, Stack, Text } from '@mantine/core'
import { faCalendar, faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatPhone } from '@phoenix-web/utils/general'

export default function BoxContactUs({
  boxStyling = true,
  calendlySupportLinkUrl,
  scheduleACallLinkText,
  supportEmail,
  supportPhone,
}: {
  boxStyling?: boolean
  calendlySupportLinkUrl: string
  scheduleACallLinkText: string
  supportEmail: string
  supportPhone: string
}) {
  return (
    <Stack
      gap="xl"
      style={{ borderRadius: 'var(--mantine-radius-sm)' }}
      bd={boxStyling ? '1px solid light-gray.6' : 'none'}
      w="100%"
      p={boxStyling ? 'lg' : '0'}
      pb={boxStyling ? 'xl' : '0'}
    >
      <Text fw={700} size="lg">
        Contact Us
      </Text>

      <Stack gap={5}>
        <Anchor className="simple-link" target="_blank" href={calendlySupportLinkUrl}>
          <FontAwesomeIcon icon={faCalendar} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />
          {scheduleACallLinkText}
        </Anchor>
        <Anchor className="simple-link" href={`mailto:${supportEmail}`}>
          <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />
          {supportEmail}
        </Anchor>
        <Anchor className="simple-link" href={`tel:${supportPhone}`}>
          <FontAwesomeIcon icon={faPhone} style={{ marginRight: 'var(--mantine-spacing-sm)' }} />
          {formatPhone(supportPhone)}
        </Anchor>
        <Text>Mon-Fri 9am to 6pm ET</Text>
      </Stack>
    </Stack>
  )
}
